.headerRow {
  display: flex;
  justify-content: center;
}

.repaymentRow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tableTextView {
  display: flex;
  flex: 1;
  border: 0.3px solid #e0e0e0;
  padding: 0.4rem 0.35rem;
}

.tableHeaderView {
  composes: tableTextView;
  justify-content: center;
}

.tableTextViewCenter {
  composes: tableTextView;
  justify-content: center;
}

.tableTextViewRight {
  composes: tableTextView;
  justify-content: flex-end;
}

.repaymentTable {
  display: flex;
  flex-direction: column;
}
